var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let { property, listing_class, listing_index, omtag, browse_modules_count, show_full_address, is_mobile } = options;
  let resource_id;

__p+='\n\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-card-compact browse-module-card js-tracking" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.prop_status ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'">\n  <div class="compact-card-save">\n    ';
 if (property.status !== 'ready_to_build') { 
__p+='\n      ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n        ';
 resource_id = property.saved_resource_id 
__p+='\n          ';
 if (resource_id) { 
__p+='\n            <a class="removeFromSaved hp-unsave" data-res-id="'+
((__t=( resource_id ))==null?'':__t)+
'">\n              <i class="ra ra-heart js-no-listing-click"></i>\n            </a>\n            <a class="addToSave hp-save" style="display:none" data-omtag="ldp:browse-more:save">\n              <i class="ra ra-heart-o js-no-listing-click" data-omtag="ldp:browse-more:save"></i>\n            </a>\n          ';
 } else { 
__p+='\n            <a class="addToSave hp-save" data-omtag="ldp:browse-more:save"><i class="ra ra-heart-o js-no-listing-click" data-omtag="ldp:browse-more:save"></i></a>\n            <a class="removeFromSaved hp-unsave" style="display:none"><i class="ra ra-heart js-no-listing-click"></i></a>\n          ';
 } 
__p+='\n      ';
 } else { 
__p+='\n        <a class="hp-save-not-logged-in" title="Save" href="#">\n          <i class="ra ra-heart-o icon-space-right align-top" data-omtag="ldp:browse-more:save"></i><span></span>\n        </a>\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n  </div>\n  <a href="'+
((__t=(property.ldp_url))==null?'':__t)+
'" class="bm-link-overlay" data-omtag="'+
((__t=( omtag ))==null?'':__t)+
'" itemprop="url"></a>\n  ';

    let photo_class = '';
    if (property.photo_url) { photo_class = "photo-not-available-480w"};
  
__p+='\n  <div class="aspect-content compact-card-image-wrapper '+
((__t=( photo_class ))==null?'':__t)+
'">\n    ';
 if (property.photo_url){ 
__p+='\n      ';
 var lazyLoadClass = listing_index > 4 ? "owl-lazy compact-card-image" : "compact-card-image"  
__p+='\n      <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="'+
((__t=( lazyLoadClass ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n    ';
 }else{ 
__p+='\n      <div class="image-placeholder"></div>\n    ';
 } 
__p+='\n    <div class="compact-card-price">\n      '+
((__t=( property.price_display ))==null?'':__t)+
'\n    </div>\n    ';
 if(property.search_flags && (property.search_flags.is_new_listing || property.search_flags.is_pending || property.search_flags.is_contingent)) { 
__p+='\n    <div class="compact-card-label">\n       ';
 if(property.search_flags.is_pending){ 
__p+='\n         <span class="label label-red display-inline-block" data-label="property-label-pending">Pending</span>\n       ';
 } else if(property.search_flags.is_contingent){ 
__p+='\n         <span class="label label-red display-inline-block" data-label="property-label-contingent">Contingent</span>\n       ';
 } else if(property.search_flags.is_new_listing){ 
__p+='\n         <span class="label label-green label-outline-none display-inline-block" data-label="property-label-new">New</span>\n       ';
 } 
__p+='\n     </div>\n     ';
 } 
__p+='\n  </div>\n  <div class="compact-card-content">\n    <div class="compact-card-address ellipsis">\n      <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n        ';
 if (property.address){ 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( property.address ))==null?'':__t)+
'</span>';
 if (show_full_address){
__p+=',';
 } 
__p+='\n          ';
 if (show_full_address){
__p+='\n            ';
 if (property.city){ 
__p+='\n              <span itemprop="addressLocality">'+
((__t=( property.city ))==null?'':__t)+
'</span>,\n            ';
 } 
__p+='\n            <span itemprop="addressRegion">'+
((__t=( property.state_code ))==null?'':__t)+
'</span>\n            <span itemprop="postalCode">'+
((__t=( property.postal_code ))==null?'':__t)+
'</span>\n          ';
 } 
__p+='\n        ';
 } else { 
__p+='\n          ';
 if (property.city){ 
__p+='\n            <span itemprop="streetAddress">'+
((__t=( property.city ))==null?'':__t)+
'</span>,\n          ';
 } 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( property.state_code ))==null?'':__t)+
'</span>\n          <span itemprop="streetAddress">'+
((__t=( property.postal_code ))==null?'':__t)+
'</span>\n        ';
 } 
__p+='\n      </span>\n      <span itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">\n        <meta itemprop="latitude" content="'+
((__t=( property.lat ))==null?'':__t)+
'">\n        <meta itemprop="longitude" content="'+
((__t=( property.lon ))==null?'':__t)+
'">\n      </span>\n    </div>\n    <div class="compact-card-meta">\n      ';
 if (((property.beds) || (property.baths)) || (property.sqft_display)){ 
__p+='\n        <ul class="list-horizontal list-style-disc">\n          ';
 if (property.beds){ 
__p+='\n            <li data-label="compact-meta-beds">'+
((__t=( property.beds ))==null?'':__t)+
' bd</li>\n          ';
 } 
__p+='\n          ';
 if (property.baths){ 
__p+='\n            <li data-label="compact-meta-baths">'+
((__t=( property.baths ))==null?'':__t)+
' ba</li>\n          ';
 } 
__p+='\n          ';
 if (property.sqft_display){ 
__p+='\n            <li class="compact-meta-sqft " data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
' sq ft</li>\n          ';
 } 
__p+='\n        </ul>\n      ';
 } else if (property.days_on_realtor) { 
__p+='\n        '+
((__t=( property.days_on_realtor ))==null?'':__t)+
' on realtor.com <sup>&reg;</sup>\n      ';
 } else {
__p+='\n        Nearby Property\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/browse_modules_card.jst.ejs